// CMS Integration for Carinas Køreskole
// Fetches data at runtime from the Auxo CMS public API with robust local fallbacks.

const API_BASE = "https://api.dev.auxo.dk/public";

// Verbatim fallback data matching exactly what was scraped and seeded
export const FALLBACK_DATA = {
  pages: [
    {
      page_slug: "index",
      title: "Køreskole i Aalborg – Tag dit kørekort hos Carinas Køreskole i Gug",
      meta_description: "Tag dit kørekort i med stil i Aalborg, hos Carinas Køreskole i Gug. Vi prioriterer små hold med fokus på den enkelte.",
      og_title: "Køreskole i Aalborg – Tag dit kørekort hos Carinas Køreskole i Gug",
      og_description: "Tag dit kørekort i med stil i Aalborg, hos Carinas Køreskole i Gug. Vi prioriterer små hold med fokus på den enkelte.",
      og_image: ["https://assets.auxodev.dk/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/9a7044-10b4e02013bb4134bc33853af7af4fb4-7emv2.jpg"],
      hero_image: ["https://assets.auxodev.dk/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/9a7044-321b9f7c775a4e86a5b9f48c2a0bac79-mv2.jpg"],
      content: `
        <h1>VELKOMMEN TIL CARINAS KØRESKOLE I GUG</h1>
        <p>Tilmeld dig med en ven og begge få en ekstra GRATIS kørelektion hver. Værdi 695 kr.​</p>
        <p>Nu også undervisning i bil med automatgear.</p>
        <p>Hos Carinas Køreskole i Gug ønsker vi at uddanne gode, trafiksikre bilister, med vægt på sikkerhed og god trafikadfærd.</p>
        <p>Her er der fokus på kvaliteten i undervisningen – både i teorilokalet og i bilen.</p>
        <p>Vi prioriterer små hold med vægt på den enkelte elevs behov.</p>
        <h2>Du kan tidligst starte på at tage kørekort 3 måneder før du fylder 17 år. Og du kan tidligst tage teoriprøve én måned før du fylder 17 år.</h2>
      `
    },
    {
      page_slug: "korekort",
      title: "Kørekort til personbil - Priser og praktisk om kørekort til personbil",
      meta_description: "Pris på kørekort hos Carinas Køreskole, hvad indeholder prisen? Kørekort til personbil. Generhvervelse af kørekort. Særlig køreundervisning.",
      og_title: "Kørekort til personbil - Priser og praktisk om kørekort til personbil",
      og_description: "Pris på kørekort hos Carinas Køreskole, hvad indeholder prisen? Kørekort til personbil. Generhvervelse af kørekort. Særlig køreundervisning.",
      og_image: ["https://assets.auxodev.dk/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/9a7044-10b4e02013bb4134bc33853af7af4fb4-7emv2.jpg"],
      hero_image: ["https://assets.auxodev.dk/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/9a7044-10b4e02013bb4134bc33853af7af4fb4-7emv2.jpg"],
      content: `
        <h1>KØREKORT TIL PERSONBIL</h1>
        <p>Kørekort til bil – hvad får du?</p>
        <h2>LOVPAKKEN: (Alt det lovpligtige undervisning)</h2>
        <ul>
          <li>30 teorilektioner á 45 min.</li>
          <li>3 kørelektioner på manøvre-kravlegård inkl. leje af bane med bil.</li>
          <li>4 kørelektioner på køreteknisk-glatbane inkl. leje af bane med bil.</li>
          <li>17 kørelektioner på vej á 45 min.</li>
          <li>Kørekortet kan også tages med automatgear (kode 78/148).</li>
        </ul>
        <p><strong>Pris 14.500 kr.</strong> Lovpakken betales i 2 rater (8.000 kr. ved holdstart, 6.500 kr. ved 2. rate).</p>
        <h2>YDERLIGERE UDGIFTER:</h2>
        <ul>
          <li>Leje af skolevogn/kørelærer til køreprøve 1.000kr</li>
          <li>Online Teori materiale i 3 måneder - Drive4you 300 kr.</li>
          <li>Ekstra kørelektioner á 45 min. 695 kr.</li>
          <li>Prøvegebyr til politiet (teoriprøve og køreprøve) 1.600kr. (hvis en prøve ikke bestås, tillægges 1.600 kr. for ny prøve</li>
          <li>Førstehjælp ca. 700 kr.</li>
          <li>Pasfoto ca. 125 kr.</li>
          <li>Lægeerklæring ca. 450 kr.</li>
          <li>Max 1 års ekstra teoriundervisning derefter 350 kr. pr. teoriaften.</li>
          <li>Administrationsgebyr ved bestilling of ny køreprøve eller ændring af dato for køreprøve 250 kr.</li>
        </ul>
        <p>Prisen på kørekortet afhænger af den enkelte elevs formåen i forhold til antallet of kørelektioner. Lovpakkens pris er baseret på kørekortbekendtgørelsens mindstekrav, derfor kan ekstra kørelektioner påregnes, hvis kørelæreren skønner, at der er behov for dette. Dette er selvfølgelig i samråd med eleven.</p>
        <h2>HVAD SKAL DU SELV SØRGE FOR?</h2>
        <p>Før at du kan tage kørekort, skal du sørge for at få en lægeerklæring hos sin egen læge. Husk at medbringe et pasfoto til kørelæreren, som sender det videre. Derudover skal du deltage i et færdselsrelateret førstehjælpskursus.</p>
        <h2>Generhvervelse/Kontrollerende køreprøve - hvad får du?​​</h2>
        <ul>
          <li>Teoriundervisnings online adgang</li>
          <li>3 kørelektioner á 45 min</li>
          <li>Leje af bil til køreprøve</li>
        </ul>
        <p><strong>Pris 4.500 kr.</strong></p>
        <p>Derudover skal der betales prøvegebyr til staten på 1.210 kr. Pasfoto 150 kr. ANT kursus  3.200 kr. (kun ved narko og spirituskørsel)</p>
        <h2>Særlig køreundervisning - hvad får du?</h2>
        <p>Lovpakken:</p>
        <ul>
          <li>Teoriundervisning - 8 lektioner.</li>
          <li>Kørelektioner - 8 lektioner</li>
          <li>Leje af skolevogn til køreprøve og kørelærer 1000 kr.</li>
        </ul>
        <p><strong>Pris 7.000 kr.</strong></p>
        <p>Derudover skal der betales prøvegebyr til staten på 1.510 kr. Ekstra køretimer 695 kr. Pasfoto 150 kr. ANT kursus 3.200 kr. (kun ved narko og spirituskørsel)</p>
        <h2>Rutine-lektioner</h2>
        <p>Hvis du ikke har kørt bil i længere tid, føler dig usikker eller bare vil have bekræftet, hvor godt du kører, kan rutine-lektioner med en erfaren kørelærer gøre underværker.</p>
        <p>I personbil - lektion á 45 min. <strong>Pris 695 kr.​</strong></p>
        <h2>TRAILERKORT / BE KØREKORT</h2>
        <ul>
          <li>4 lektioner teori</li>
          <li>6 lektioner på vej</li>
          <li>Leje af bil og trailer til praktisk prøve</li>
        </ul>
        <p><strong>Pris 5.100 kr.</strong></p>
        <p>Alt undervisning foregår på dansk. Alle priser er inkl. moms. Der tages forbehold for prisændringer.</p>
        <p>Husk at melde afbud på 3051 7269, af kørelektion på dagen inden kl. 7.00, hvis du bliver syg eller forhindret, ellers koster det 695 kr. pr. lektion - også hvis du ved fremmøde mangler lektionsplan eller glemmer at møde op.</p>
        <p>Teoriundervisningen foregår på hold på Gugvej 186 D, kld. tv., 9210 Aalborg SØ.​​</p>
      `
    },
    {
      page_slug: "priser",
      title: "Priser på kørekort - Carinas Køreskole",
      meta_description: "Pris på kørekort hos Carinas Køreskole, hvad indeholder prisen? Kørekort til personbil. Generhvervelse af kørekort. Særlig køreundervisning.",
      og_title: "Priser på kørekort - Carinas Køreskole",
      og_description: "Pris på kørekort hos Carinas Køreskole, hvad indeholder prisen? Kørekort til personbil. Generhvervelse af kørekort. Særlig køreundervisning.",
      og_image: ["https://assets.auxodev.dk/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/9a7044-10b4e02013bb4134bc33853af7af4fb4-7emv2.jpg"],
      hero_image: ["https://assets.auxodev.dk/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/9a7044-10b4e02013bb4134bc33853af7af4fb4-7emv2.jpg"],
      content: `
        <h1>PRISER PÅ KØREKORT</h1>
        <p>Her finder du en overskuelig oversigt over vores priser på kørekort til personbil, generhvervelse, særlig køreundervisning, trailerkort (BE) samt rutinelektioner.</p>
        <p>Designet er inspireret af Aalborg Køreskole med en klar struktur, rater og gennemskuelige ekstra udgifter.</p>
      `
    },
    {
      page_slug: "teori",
      title: "Teoriundervisning og Prøvekrav - Carinas Køreskole",
      meta_description: "Læs mere om undervisningslokalet i Gug. Nyindrettede teorilokale. Det gode, fysiske læringsmiljø. Undervisningen tilrettelægges efter den enkelte elev. Små hold. Undervisning på dansk.",
      og_title: "Undervisningslokalet hos Carinas Køreskole",
      og_description: "Læs mere om undervisningslokalet i Gug. Nyindrettede teorilokale. Det gode, fysiske læringsmiljø. Undervisningen tilrettelægges efter den enkelte elev. Små hold. Undervisning på dansk.",
      og_image: ["https://assets.auxodev.dk/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/9a7044-10b4e02013bb4134bc33853af7af4fb4-7emv2.jpg"],
      hero_image: ["https://assets.auxodev.dk/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/9a7044-9ab33a1ec0e84aff9252780df2d12586-mv2-d-5184-3456-s-4-2.jpg"],
      content: `
        <h1>UNDERVISNINGSLOKALET</h1>
        <p>Du bliver undervist i nyindrettede lokaler, hvor der er tænkt på det gode fysiske læringsmiljø, hvor du føler dig tilpas i omgivelserne.</p>
        <p>Holdene er små med max. 8 personer. Det betyder, at du får det optimale ud af undervisningen og at der er god tid til den enkelte elev.</p>
        <p>Undervisningen og køretimerne vil blive tilrettelagt efter den enkelte elevs behov og på en måde, hvor alle elever føler sig trygge. Der er fokus på det positive undervisningsmiljø, som danner grundlag for den bedste læring.</p>
        <p>Alt undervisning foregår på dansk.</p>
        <p>Husk at melde afbud på 3051 7269, senest 8 timer før din kørelektion, hvis du bliver syg eller forhindret ellers koster det 600 kr. pr. lektion. Dette gælder også, hvis du glemmer at møde op.</p>
        <p>Adressen er Gugvej 186D, kld. tv. i Gug. Bus nr. 15 holder lige udenfor døren, så det er nemt for dig at komme dertil.</p>
        <h2>KØRETEKNISK ANLÆG</h2>
        <p>Alt manøvre- og glatbanekørsel foregår på Køreteknisk Anlæg i Viborg eller Støvrings Køreteknisk Anlæg.</p>
        <p>Vi sørger for, at I bliver fragtet frem og tilbage med bus.</p>
        <h2>PRØVEKRAV</h2>
        <p>Eleven kan tidligst starte på at tage kørekort 3 måneder før eleven er fylder 17 år. Er eleven ældre end det, kan eleven selvfølgelig starte når som helst. Inden eleven kan begynde kørslen i trafikken med andre billister, skal eleven have haft mindst 4 lektioner på manøvrebane.</p>
        <h3>Teoriprøven</h3>
        <p>Teoriprøverne er digitale og der skal logges ind med MitID. Det is en løsning som giver en forbedret oplevelse for den enkelte elev i prøvesituationen. Eleven kan individuelt læse og lytte til hvert enkelt af de 25 spørgsmål og ad flere omgange kan eleven vende tilbage for at besvare et spørgsmål.</p>
        <p>Man må max. have 5 fejl i teoriprøven ellers er prøven ikke bestået, og eleven skal betale for et nyt stempelgebyr til staten, før eleven kan gå op til en ny teoriprøve.</p>
        <p>Eleven kan tidligst går op til teoriprøven 1 måned før du fylder 17 år.</p>
        <p>Teoriprøvens varighed er ca. 30 min og foregår ved Amu Center Sofievej 61, 9000 Aalborg.</p>
        <p>Du får resultatet af vide med det samme.</p>
        <h3>Praktisk prøve</h3>
        <p>Du skal have været hele undervisningsplanen igennem inden du kan gå op til en køreprøve.</p>
        <p>Det vil sige, at du skal have haft mindst 30 lektioner i teori, have kørt mindst 17 lektioner på vej, have været mindst 3 lektioner på manøvrebane og have haft mindst 4 lektioner på køreteknisk anlæg.</p>
        <p>Kørelæren kan først bestille køreprøven når eleven har bestået teoriprøven.</p>
        <p>Eleven skal være fyldt år 17 før eleven kan komme til køreprøven.</p>
        <p>Køreprøven varer ca. 40 min. Den kan dog forlænges eller afbrydes.</p>
        <p>Prøven gennemføres sammen med en prøvesagkyndig.</p>
        <p>Eleven vil i forbindelse med prøven blive overhørt i tekniske spørgsmål vedr. bilen.</p>
        <p>Lektionsplanen skal være udfyldt korrekt.</p>
        <p>Eleven får resultatet af vide med det samme.</p>
      `
    },
    {
      page_slug: "forstehjaelp",
      title: "Førstehjælp til kørekort | Carinas Køreskole",
      meta_description: "Læs mere om reglerne vedr. førstehjælp når du skal tage kørekort. Tilmeld dig et førstehjælpskursus.",
      og_title: "Førstehjælp til kørekort | Carinas Køreskole",
      og_description: "Læs mere om reglerne vedr. førstehjælp når du skal tage kørekort. Tilmeld dig et førstehjælpskursus.",
      og_image: ["https://assets.auxodev.dk/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/9a7044-10b4e02013bb4134bc33853af7af4fb4-7emv2.jpg"],
      hero_image: ["https://assets.auxodev.dk/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/9a7044-0efbe65ad02b45b183e672953878c28d-mv2_1.jpg"],
      content: `
        <h1>FØRSTEHJÆLP</h1>
        <p>Inden du kan tage kørekort, skal du deltage i et færdselsrelateret førstehjælpskursus.</p>
        <p>Du kan evt. tilmelde dig et kursus hos:</p>
        <p><strong>Førstehjælp v/ Michael</strong><br/>Telefon: 6166 1084<br/>Emal: mb.foerstehjaelp@gmail.com</p>
        <p>Skriv en mail eller send en sms for tilmelding.</p>
        <p>Kursus finder sted i Hasserisgade 5, 9000 Aalborg.</p>
        <p><strong>Pris: 700 kr.</strong></p>
        <p><strong>Datoer: 2026</strong><br/>Januar. d. 10 - 14 - 29<br/>Februar. d. 7<br/>Marts. d. 1 -14- 29<br/>April d. 11 - 26<br/>Maj d. 9 - 30<br/>Juni d. 13 - 27</p>
        <p>Carinas Køreskole kan også hjælpe med at tilmelde dig et førstehjælpskursus.</p>
      `
    },
    {
      page_slug: "om-carina",
      title: "Bilen og kørelæreren | Carinas Køreskole",
      meta_description: "Tag dit kørekort med stil i en Audi Q3. Læs mere om kørelærer Carina Svensson, og hendes erfaringer som kørelærer.",
      og_title: "Bilen og kørelæreren | Carinas Køreskole",
      og_description: "Tag dit kørekort med stil i en Audi Q3. Læs mere om kørelærer Carina Svensson, og hendes erfaringer som kørelærer.",
      og_image: ["https://assets.auxodev.dk/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/9a7044-10b4e02013bb4134bc33853af7af4fb4-7emv2.jpg"],
      hero_image: ["https://assets.auxodev.dk/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/9a7044-321b9f7c775a4e86a5b9f48c2a0bac79-mv2.jpg"],
      content: `
        <h1>BILEN</h1>
        <h2>Audi Q3</h2>
        <p>Du kommer til at køre i en ny og moderne skolevogn, en Audi Q3, hvor sikkerhed og komfort er helt i top. Det er vigtigt, at du får en god køreoplevelse og at bilen er trafiksikker. Udsynet er rigtig godt, da man sidder højt i bilen.</p>
        <h2>Bil med automatgear ID3</h2>
        <p>(Billede på vej)</p>
        <h1>KØRELÆREREN</h1>
        <h2>Carina Svensson</h2>
        <p>Jeg er uddannet kørelærer og blev færdig i november 2018. Jeg har siden jeg blev færdiguddannet arbejdet som kørelære i Viborg og i august 2019 startede jeg min egen køreskole i Gug.</p>
        <p>Jeg er helt opkvalificeret i alt nyt teori og viden indenfor trafik, kørsel, og trafiksikkerhed.</p>
      `
    },
    {
      page_slug: "kontakt",
      title: "Holdstart og tilmelding - Carinas Køreskole",
      meta_description: "Tilmeld dig holdstart hos Carinas Køreskole i Gug. Datoer for holdstart. Tilmelding.",
      og_title: "Holdstart og tilmelding - Carinas Køreskole",
      og_description: "Tilmeld dig holdstart hos Carinas Køreskole i Gug. Datoer for holdstart. Tilmelding.",
      og_image: ["https://assets.auxodev.dk/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/9a7044-10b4e02013bb4134bc33853af7af4fb4-7emv2.jpg"],
      hero_image: ["https://assets.auxodev.dk/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/unadjustednonraw-thumb-2b46.jpg"],
      content: `
        <h1>HOLDSTART OG TILMELDING</h1>
        <p>Du tilmelder dig i formularen.</p>
        <p>Skriv datoen for det hold du gerne vil tilmeldes i emnefeltet.</p>
        <p>Skriv din fødselsdato i beskedfeltet samt evt. andre kommentarer eller ønsker.</p>
        <p>Du er også velkommen til at kontakte mig på mail eller telefon.</p>
        <p>Send evt. en sms med dit navn, så kontakter jeg dig hurtigst muligt.​​​​​</p>
        <p>OBS: Ved udeblivelse/ afmelding  fra opstartsdato uden rettidigt afbud (2 uger) opkræves gebyr på 3.000 kr.</p>
        <p>Vælger du at stoppe midt i forløbet, får du ikke penge tilbage for lovpakken</p>
        <p>Adressen på teorilokalet: Gugvej 186 D, kld. tv., 9210 Aalborg SØ (Bus nr. 15 holder lige ved døren)</p>
      `
    },
    {
      page_slug: "persondata",
      title: "Sådan behandler vi dine persondata | Carinas Køreskole",
      meta_description: "Sådan behandler vi dine persondata | Carinas Køreskole",
      og_title: "Sådan behandler vi dine persondata | Carinas Køreskole",
      og_description: "Sådan behandler vi dine persondata | Carinas Køreskole",
      og_image: ["https://assets.auxodev.dk/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/9a7044-10b4e02013bb4134bc33853af7af4fb4-7emv2.jpg"],
      hero_image: ["https://assets.auxodev.dk/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/gdpr.jpg"],
      content: `
        <h1>SÅDAN BEHANDLER VI DINE PERSONDATA</h1>
        <p>Oplysningspligt – elever</p>
        <p>Behandling af persondata i tilknytning til din uddannelse</p>
        <p>Carinas Køreskole, Gugvej 186 D, kld. tv., 9210 Aalborg SØ, CVR nr. 40126996 er dataansvarlig for behandlingen af de personoplysninger, som vi har modtaget om dig. Du kan kontakte os på Tlf. 3051 7269, e-mail: carinaskoereskole@gmail.com.</p>
        <p>Behandlingen af dine personoplysninger: Carinas Køreskole har brug for visse personoplysninger for at kunne yde den undervisning, der er aftalt mellem køreskolen og dig (iht. persondataforordningens art. 6, 1, b, art. 6, 1, c og bekendtgørelse om kørekort). Der vil være tale om behandling af følgende personoplysninger: ID-oplysninger, CPR-nr., fødeland, evt. bedømmelsesskema, ansøgningsskema, lektionsplan, kursusbeviser evt. navn og CPR-nr. på indehaver(e) of forældremyndigheden (samtykkeerklæring) samt evt. ansøgning om dispensation.</p>
        <p>Opbevaring og sletning: Oplysninger angående din undervisning herunder lektionsplan skal opbevares i 2 år iht. bekendtgørelsen om kørekort. Aftalegrundlaget for den løbende undervisning hos køreskolen vil blive opbevaret i 5 år plus indeværende regnskabsår iht. bogføringsloven, eftersom at aftalegrundlaget skal anses som regnskabsmateriale. Ansøgningsskema vil umiddelbart blive slettet efter, at skemaet er videregivet til politiet. Bedømmelsesskema bliver udleveret til dig, og vil herefter ikke blive opbevaret hos køreskolen. Indehaverne of forældremyndigheden udfylder en samtykkeerklæring, hvis den pågældende elevs alder er 17 år. Denne samtykkeerklæring, bevis fra førstehjælpskursus og ANT-kursusbevis behandles hos Borgerservice. Dokumenterne returneres herefter til køreskolen som videregiver dokumenterne til eleven, hvorfor de efterfølgende ikke vil være tilgængelige for køreskolen. Ansøgningen angående dispensation videregives til Færdselsstyrelsen, og vil ikke være tilgængelig for køreskolen til viderebehandling.</p>
        <p>Modtagere, der kan behandle dine oplysninger: Under undervisningsforløbet videregiver eller overlader køreskolen dine personoplysninger til følgende modtagere: Politiet og tilsynsførende, Evt. samarbejdende kørelærere, Manøvrebaner og køreteknisk anlæg, Evt. tilmelding til udbydere of online undervisningsprogrammer, Kommuner, herunder Borgerservice og Landsforening, Ekstern underviser i førstehjælp, Administrationscentre, Færdselsstyrelsen, It-leverandører.</p>
        <p>Dine rettigheder: Efter lovgivningen i databeskyttelsesforordningen har du en række rettigheder: Ret til at få indsigt i dine oplysninger, Ret til at få urigtige oplysninger rettet, I særlige tilfælde at få slettet og begrænset oplysninger, Ret til at gøre indsigelse mod visse behandlinger of oplysninger, Modtage oplysninger i et struktureret, almindeligt anvendt og maskinlæsbart format samt at få overført disse oplysninger fra én dataansvarlig til en anden uden hindring. Du har mulighed for at klage over vores behandling of dine personoplysninger til Datatilsynet. Du finder Datatilsynets kontaktoplysninger på Datatilsynets hjemmeside www.datatilsynet.dk.</p>
        <p>Hvis du vil gøre brug of dine rettigheder skal du kontakte os via ovenstående kontaktoplysninger.</p>
      `
    },
    {
      page_slug: "provekrav",
      title: "Prøvekrav til kørekort - Carinas Køreskole",
      meta_description: "Se kravene til teoriprøven og den praktiske prøve hos Carinas Køreskole. Læs om MitID, fejlgrænser og varighed.",
      og_title: "Prøvekrav til teoriprøve og køreprøve",
      og_description: "Se kravene til teoriprøven og den praktiske prøve hos Carinas Køreskole. Læs om MitID, fejlgrænser og varighed.",
      og_image: ["https://assets.auxodev.dk/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/9a7044-10b4e02013bb4134bc33853af7af4fb4-7emv2.jpg"],
      hero_image: ["https://assets.auxodev.dk/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/9a7044-9ab33a1ec0e84aff9252780df2d12586-mv2-d-5184-3456-s-4-2.jpg"],
      content: `
        <h1>PRØVEKRAV TIL KØREKORT</h1>
        <p>Her kan du læse om kravene til teoriprøven og den praktiske køreprøve, samt hvad du selv skal sørge for inden prøverne.</p>
        <h2>Generelle krav</h2>
        <p>Du kan tidligst starte på at tage kørekort 3 måneder før du fylder 17 år. Er du ældre end det, kan du selvfølgelig starte når som helst.</p>
        <p>Inden du kan begynde kørslen i trafikken med andre bilister, skal du have haft mindst 4 lektioner på manøvrebane (kravlegård).</p>
        <h2>Teoriprøven</h2>
        <p>Teoriprøverne er digitale, og der skal logges ind med MitID. Det er en løsning, som giver en forbedret oplevelse for den enkelte elev i prøvesituationen. Du kan individuelt læse og lytte til hvert enkelt af de 25 spørgsmål, og ad flere omgange kan du vende tilbage for at besvare et spørgsmål.</p>
        <ul>
          <li>Man må max. have 5 fejl i teoriprøven, ellers er prøven ikke bestået.</li>
          <li>Hvis prøven ikke bestås, skal du betale et nyt prøvegebyr til staten, før du kan gå op til en ny teoriprøve.</li>
          <li>Du kan tidligst gå op til teoriprøven 1 måned før du fylder 17 år.</li>
          <li>Teoriprøvens varighed er ca. 30 minutter og foregår ved AMU Center, Sofievej 61, 9000 Aalborg.</li>
          <li>Du får resultatet at vide med det samme.</li>
        </ul>
        <h2>Praktisk prøve (Køreprøven)</h2>
        <p>Du skal have været hele undervisningsplanen igennem, inden du kan gå op til en køreprøve.</p>
        <p>Det vil sige, at du skal have haft mindst 30 lektioner i teori, have kørt mindst 17 lektioner på vej, have været mindst 3 lektioner på manøvrebane og have haft mindst 4 lektioner på køreteknisk anlæg.</p>
        <ul>
          <li>Kørelæreren kan først bestille køreprøven, når du har bestået teoriprøven.</li>
          <li>Du skal være fyldt 17 år, før du kan komme til køreprøven.</li>
          <li>Køreprøven varer ca. 40 minutter. Den kan dog forlænges eller afbrydes.</li>
          <li>Prøven gennemføres sammen med en prøvesagkyndig fra Færdselsstyrelsen.</li>
          <li>Du vil i forbindelse med prøven blive overhørt i tekniske spørgsmål vedrørende bilen (f.eks. dæk, styretøj, bremser, lygter).</li>
          <li>Lektionsplanen skal være udfyldt korrekt og underskrevet af både dig og kørelæreren.</li>
          <li>Du får resultatet at vide med det samme.</li>
        </ul>
      `
    },
    {
      page_slug: "koreteknisk-anlaeg",
      title: "Køreteknisk anlæg - Manøvrebane & Glatbane | Carinas Køreskole",
      meta_description: "Alt manøvre- og glatbanekørsel foregår på Køreteknisk Anlæg i Viborg eller Støvrings Køreteknisk Anlæg. Vi sørger for transport.",
      og_title: "Køreteknisk anlæg - Manøvrebane & Glatbane",
      og_description: "Alt manøvre- og glatbanekørsel foregår på Køreteknisk Anlæg i Viborg eller Støvrings Køreteknisk Anlæg. Vi sørger for transport.",
      og_image: ["https://assets.auxodev.dk/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/road_1.jpg"],
      hero_image: ["https://assets.auxodev.dk/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/road_1.jpg"],
      content: `
        <h1>KØRETEKNISK ANLÆG</h1>
        <p>Alt manøvre- og glatbanekørsel foregår på Køreteknisk Anlæg i Viborg eller Støvrings Køreteknisk Anlæg.</p>
        <p>Vi sørger for, at I bliver fragtet frem og tilbage med bus.</p>
        <h2>Se mere om manøvre- og glatbanekørsel her:</h2>
        <p>Hos Carinas Køreskole ønsker vi at give dig den bedste og mest trygge oplevelse på banen.</p>
      `
    }
  ],
  holdstart_dates: [
    { title: "Mandag d. 5/10", time: "Fra kl. 16:30", status: "Ledig", category: "Køreskolen i Gug" },
    { title: "Tirsdag d. 3/11", time: "Fra kl. 16:30", status: "FULD BOOKET", category: "Køreskolen i Gug" },
    { title: "Mandag d. 4/1 2027", time: "Fra kl. 16:30", status: "Ledig", category: "Køreskolen i Gug" },
    { title: "Tirsdag d. 2/2-2027", time: "Fra kl. 16:30", status: "Ledig", category: "Køreskolen i Gug" },
    { title: "Lørdag d. 17/10", time: "1. gangs undervisning er lørdag d. 17/10 fra 9.00 til 15.00, derefter torsdag fra kl. 14.45.", status: "Ledig", category: "Skipper Clement" },
    { title: "Januar 2027: Lørdag d. 9/1", time: "Holdstart er lørdag d. 9. januar fra kl. 9.00 til 15.00, derefter torsdag fra kl. 14.45.", status: "Ledig", category: "Skipper Clement" },
    { title: "April 2027", time: "Tidspunkt kommer senere", status: "Ledig", category: "Skipper Clement" },
    { title: "Lørdag d. 24/10", time: "Holdstart lørdag d. 24/10 kl. 9.00 til 15.00, derefter onsdag fra kl. 14.", status: "Ledig", category: "Klostermark Skolen" },
    { title: "Januar 2027: Lørdag d. 16/1", time: "Holdstart lørdag d. 16/1 2027 fra 9 til 15, derefter onsdag fra kl. 14.", status: "Ledig", category: "Klostermark Skolen" },
    { title: "April 2027", time: "Tidspunkt kommer senere", status: "Ledig", category: "Klostermark Skolen" },
    { title: "Hold 1: November 2026", time: "Opstart november 2026", status: "Ledig", category: "SEA Efterskole" },
    { title: "Hold 2: 2027", time: "Opstart i 2027 – dato kommer senere", status: "Ledig", category: "SEA Efterskole" },
    { title: "Hold 3: 2027", time: "Opstart i 2027 – dato kommer senere", status: "Ledig", category: "SEA Efterskole" }
  ],
  prices: [
    {
      title: "Lovpakken",
      price: "14.500 kr.",
      subtitle: "Alt det lovpligtige undervisning (Betales i 2 rater: 8.000 kr. og 6.500 kr.)",
      included: "<ul><li>30 teorilektioner á 45 min.</li><li>3 kørelektioner på manøvre-kravlegård inkl. leje af bane med bil.</li><li>4 kørelektioner på køreteknisk-glatbane inkl. leje af bane med bil.</li><li>17 kørelektioner på vej á 45 min.</li><li>Kørekortet kan også tages med automatgear (kode 78/148).</li></ul>",
      extra_costs: "<ul><li>Leje af skolevogn/kørelærer til køreprøve 1.000kr</li><li>Online Teori materiale i 3 måneder - Drive4you 300 kr.</li><li>Ekstra kørelektioner á 45 min. 695 kr.</li><li>Prøvegebyr til politiet (teoriprøve og køreprøve) 1.600kr. (hvis en prøve ikke bestås, tillægges 1.600 kr. for ny prøve)</li><li>Førstehjælp ca. 700 kr.</li><li>Pasfoto ca. 125 kr.</li><li>Lægeerklæring ca. 450 kr.</li><li>Max 1 års ekstra teoriundervisning derefter 350 kr. pr. teoriaften.</li><li>Administrationsgebyr ved bestilling of ny køreprøve eller ændring af dato for køreprøve 250 kr.</li></ul>"
    },
    {
      title: "Generhvervelse",
      price: "4.500 kr.",
      subtitle: "Generhvervelse/Kontrollerende køreprøve",
      included: "<ul><li>Teoriundervisnings online adgang</li><li>3 kørelektioner á 45 min</li><li>Leje af bil til køreprøve</li></ul>",
      extra_costs: "<ul><li>Prøvegebyr til staten på 1.210 kr.</li><li>Pasfoto 150 kr.</li><li>ANT kursus 3.200 kr. (kun ved narko og spirituskørsel)</li></ul>"
    },
    {
      title: "Særlig køreundervisning",
      price: "7.000 kr.",
      subtitle: "Særlig køreundervisning - hvad får du?",
      included: "<ul><li>Teoriundervisning - 8 lektioner.</li><li>Kørelektioner - 8 lektioner</li><li>Leje af skolevogn til køreprøve og kørelærer 1000 kr.</li></ul>",
      extra_costs: "<ul><li>Prøvegebyr til staten på 1.510 kr.</li><li>Ekstra køretimer 695 kr.</li><li>Pasfoto 150 kr.</li><li>ANT kursus 3.200 kr. (kun ved narko og spirituskørsel)</li></ul>"
    },
    {
      title: "Trailerkort / BE",
      price: "5.100 kr.",
      subtitle: "TRAILERKORT / BE KØREKORT",
      included: "<ul><li>4 lektioner teori</li><li>6 lektioner på vej</li><li>Leje af bil og trailer til praktisk prøve</li></ul>",
      extra_costs: ""
    },
    {
      title: "Rutine-lektioner",
      price: "695 kr.",
      subtitle: "Rutine-lektioner - I personbil - lektion á 45 min.",
      included: "<p>Hvis du ikke har kørt bil i længere tid, føler dig usikker eller bare vil have bekræftet, hvor godt du kører, kan rutine-lektioner med en erfaren kørelærer gøre underværker.</p>",
      extra_costs: ""
    }
  ],
  passed_students: [
    {
      "id": "3e049807-a039-4ba1-b36f-8177a5b8d16e",
      "name": "Alex",
      "passed_date": "Juni 2026",
      "image": [
        "https://assets.auxodev.dk/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/alex.jpg"
      ],
      "testimonial": "Super fedt forløb! Carina er mega rolig og god til at lære fra sig. Det var en fornøjelse at køre i den fede Audi Q3."
    },
    {
      "id": "a2f418b4-2696-49fe-b669-5795b0181de9",
      "name": "Emelie",
      "passed_date": "Maj 2026",
      "image": [
        "https://assets.auxodev.dk/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/emelie.jpg"
      ],
      "testimonial": "Tusind tak til Carina for den mest trygge køreundervisning. Jeg var ret nervøs i starten, men hun gav mig fuldstændig ro på."
    },
    {
      "id": "af807d37-0aae-4e41-b324-35eddca940e8",
      "name": "Emil",
      "passed_date": "Maj 2026",
      "image": [
        "https://assets.auxodev.dk/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/emil.jpg"
      ],
      "testimonial": "Klasse køreskole! Små teorihold gjorde det hyggeligt, og kørslen var altid sjov og lærerig. Bestod i første forsøg!"
    },
    {
      "id": "da8a6468-66ce-4632-af93-e6f193b417f6",
      "name": "Emilie",
      "passed_date": "April 2026",
      "image": [
        "https://assets.auxodev.dk/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/emilie.jpg"
      ],
      "testimonial": "Jeg tog kørekort med automatgear i elbilen (ID.3). Det var en fantastisk oplevelse, og Carina er simpelthen den bedste kørelærer!"
    },
    {
      "id": "d2509152-4db1-4a49-9d3e-a225c745e16d",
      "name": "Marie",
      "passed_date": "April 2026",
      "image": [
        "https://assets.auxodev.dk/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/marie.jpg"
      ],
      "testimonial": "En utrolig personlig og tryg oplevelse. Carina har altid overskud og smil på læben, selv når man laver fejl. Kan varmt anbefales!"
    },
    {
      "id": "bd61bc9a-02b6-4f8d-9fca-e8d52817f575",
      "name": "Mark",
      "passed_date": "Marts 2026",
      "image": [
        "https://assets.auxodev.dk/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/mark.jpg"
      ],
      "testimonial": "Rigtig god og struktureret undervisning. Man føler sig super godt klædt på til både teoriprøven og den praktiske prøve."
    },
    {
      "id": "4099fe0f-0639-4a68-a693-cd2d76c40e9f",
      "name": "Nadia",
      "passed_date": "Februar 2026",
      "image": [
        "https://assets.auxodev.dk/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/nadia.jpg"
      ],
      "testimonial": "Fantastisk forløb! Carina formår at gøre teoritimerne spændende, og kørslen er helt i top. Jeg er så glad for mit kørekort!"
    },
    {
      "id": "7557ed48-43ee-43a2-bff5-90377b305b73",
      "name": "Signe",
      "passed_date": "Januar 2026",
      "image": [
        "https://assets.auxodev.dk/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/signe.jpg"
      ],
      "testimonial": "Det bedste valg jeg har taget! Carina skaber en utrolig hyggelig og tryg atmosfære, hvor der er plads til alle."
    }
  ]
};

export function hasFixedDate(title) {
  if (!title) return false;
  const t = title.trim();
  if (/^Uge\s+\d+/i.test(t)) return false;
  if (/^(Januar|Februar|Marts|April|Maj|Juni|Juli|August|September|Oktober|November|December)(\s+\d{4})?$/i.test(t)) return false;
  return true;
}

export function parseHoldDateForSort(hold) {
  if (!hold || !hold.title) return 99999999;
  const title = (hold.title || "").toLowerCase();
  
  // Year detection
  let year = 2026;
  if (title.includes("2027")) year = 2027;
  else if (title.includes("2028")) year = 2028;

  // Hold number modifier if any
  let holdOrderOffset = 0;
  if (title.includes("hold 1")) holdOrderOffset = 1;
  else if (title.includes("hold 2")) holdOrderOffset = 2;
  else if (title.includes("hold 3")) holdOrderOffset = 3;

  // 1. Specific date like "4/11" (Nov 4, 2026) or "4/1 2027" (Jan 4, 2027)
  const slashMatch = title.match(/(\d{1,2})\/(\d{1,2})/);
  if (slashMatch) {
    const day = parseInt(slashMatch[1], 10);
    const month = parseInt(slashMatch[2], 10);
    return new Date(year, month - 1, day).getTime() + holdOrderOffset;
  }

  // 2. Week match like "uge 43"
  const weekMatch = title.match(/uge\s*(\d{1,2})/);
  if (weekMatch) {
    const week = parseInt(weekMatch[1], 10);
    // Week 43 in late October
    const approxMonth = Math.floor((week * 7) / 30.5) - 1;
    const approxDay = ((week * 7) % 30) || 15;
    return new Date(year, approxMonth, approxDay).getTime() + holdOrderOffset;
  }

  // 3. Month match like "januar 2027" or "april 2027"
  const months = ["januar", "februar", "marts", "april", "maj", "juni", "juli", "august", "september", "oktober", "november", "desember", "december"];
  for (let i = 0; i < months.length; i++) {
    if (title.includes(months[i])) {
      const monthIdx = i >= 11 ? 11 : i;
      return new Date(year, monthIdx, 15).getTime() + holdOrderOffset;
    }
  }

  return new Date(year, 5, 1).getTime() + holdOrderOffset * 1000000;
}

const TERM_CATEGORY_MAP = {
  "koereskolen-i-gug": "Køreskolen i Gug",
  "skipper-clement": "Skipper Clement",
  "klostermark-skolen": "Klostermark Skolen",
  "sea-efterskole": "SEA Efterskole"
};

export function normalizeHoldstartDate(item) {
  if (!item) return item;
  let category = item.category;
  if (!category && item.terms?.category && item.terms.category.length > 0) {
    const slug = item.terms.category[0];
    category = TERM_CATEGORY_MAP[slug] || slug;
  }
  if (category && TERM_CATEGORY_MAP[category]) {
    category = TERM_CATEGORY_MAP[category];
  }
  return {
    ...item,
    category: category || "Køreskolen i Gug"
  };
}

export function sortHoldstartDates(dates) {
  if (!Array.isArray(dates)) return [];
  return [...dates]
    .map(normalizeHoldstartDate)
    .sort((a, b) => parseHoldDateForSort(a) - parseHoldDateForSort(b));
}

// Helper to fetch a collection with fallback
export async function getCollection(collectionName) {
  try {
    const res = await fetch(`${API_BASE}/content/${collectionName}`);
    if (!res.ok) throw new Error(`Failed to fetch ${collectionName}`);
    const data = await res.json();
    if (Array.isArray(data) && data.length > 0) {
      return collectionName === "holdstart_dates" ? sortHoldstartDates(data) : data;
    }
    // Try v2 endpoint
    const resV2 = await fetch(`${API_BASE}/v2/content/${collectionName}`);
    if (resV2.ok) {
      const dataV2 = await resV2.json();
      if (dataV2 && Array.isArray(dataV2.items) && dataV2.items.length > 0) {
        return collectionName === "holdstart_dates" ? sortHoldstartDates(dataV2.items) : dataV2.items;
      }
    }
  } catch (err) {
    console.warn(`CMS Fetch Error for ${collectionName}, using fallback:`, err);
  }
  const fallback = FALLBACK_DATA[collectionName] || [];
  return collectionName === "holdstart_dates" ? sortHoldstartDates(fallback) : fallback;
}

// Helper to fetch a single page by slug
export async function getPageBySlug(slug) {
  const pages = await getCollection("pages");
  return pages.find(p => p.page_slug === slug) || FALLBACK_DATA.pages.find(p => p.page_slug === slug);
}
